/*
 * Copyright (c) 2021 WIT Software. All rights reserved.
 *
 * WIT Software Confidential and Proprietary information. It is strictly forbidden for 3rd parties to modify, decompile,
 * disassemble, defeat, disable or circumvent any protection mechanism; to sell, license, lease, rent, redistribute or
 * make accessible to any third party, whether for profit or without charge.
 *
 */

import React from 'react';

import { ButtonOption } from 'types/components/SelectOptions';
import { Option } from '..';

interface ISelectOptionsProps {
  options?: ButtonOption[];
}

const SelectOptions: React.FunctionComponent<ISelectOptionsProps> = (props: ISelectOptionsProps) => {
  const { options } = props;

  return options ? (
    <div className="buttons-container body-buttons">
      {options.map((button) => {
        return <Option option={button} key={button.id} />;
      })}
    </div>
  ) : null;
};

export default SelectOptions;
